import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GamedayActionTypes } from '../data/actions';
import { Reset } from './actions';

@Injectable()
export class ProgressBarChartEffects {
  @Effect()
  public readonly chart: Observable<Action> = this.actions.pipe(
    ofType(GamedayActionTypes.ResetData),
    map(() => new Reset())
  );

  constructor(private readonly actions: Actions) {}
}
